<ng-container *ngIf="!config && !uuid">
  <section class="page-center-card py-4 py-lg-5 px-xl-5 px-md-4 px-2">
    <div class="card m-5">
      <div class="card-body">

        <label for="cliente">Cliente</label>
        <select [formControl]="form.controls.cliente" name="cliente" id="cliente" class="form-control">
          <option *ngFor="let o of listaClientes" [ngValue]="o">{{o.nomefantasia}}</option>
        </select>
        <app-msg-erro [control]="form.controls.cliente"></app-msg-erro>

        <label class="mt-4" for="tipovistoria">Tipo de vistoria</label>
        <select [formControl]="form.controls.tipoVistoria" name="tipovistoria" id="tipovistoria" class="form-control">
          <option *ngFor="let o of listaTipoVistoria" [ngValue]="o">{{o.nome}}</option>
        </select>
        <app-msg-erro [control]="form.controls.tipoVistoria"></app-msg-erro>

        <label class="mt-4" for="nome">Nome da configuração</label>
        <input [formControl]="form.controls.nome" type="text" name="nome" id="nome" class="form-control">
        <app-msg-erro [control]="form.controls.nome"></app-msg-erro>

        <button (click)="novoConfigLaudo()" [disabled]="form.invalid"
          class="btn btn-lg btn-success mt-5 w-100">Confirmar</button>
      </div>
    </div>
  </section>
</ng-container>

<section *ngIf="config" class="py-4 py-lg-5 px-lg-5 px-md-4 px-2">

  <div class="mb-4">
    <app-card-collapse title="Nome da configuração">
      <div class="rounded bg-light p-2 mb-2">
        <label class="" for="exemploVistoria">Copiar configuração de laudo</label>
        <select [formControl]="exemploVistoria" name="exemploVistoria" id="exemploVistoria" class="form-control">

          <option *ngFor="let o of listaConfigExemplo" [value]="o.uuid"> {{o.id + ' - ' + o.nomeConfig}}</option>

        </select>
        <app-msg-erro [control]="exemploVistoria"></app-msg-erro>
      </div>
      <label for="nome">Nome da configuração</label>
      <input [formControl]="form.controls.nome" type="text" name="nome" id="nome" class="form-control">
      <app-msg-erro [control]="form.controls.nome"></app-msg-erro>


    </app-card-collapse>
  </div>

  <app-card-collapse title="Tipo de Configuração">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 p-2">
        <app-checkbox (checkedChange)="selecionarCombinado($event)" [label]="combinado.nome"
          [(checked)]="combinado.checked" [(disabled)]="combinado.disabled"></app-checkbox>
      </div>
    </div>
  </app-card-collapse>

  <ng-container *ngIf="permissaoAuditoria">
    <div class="my-4">
      <app-card-collapse title="Auditoria">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 p-2">
            <app-checkbox (checkedChange)="selecionarAuditoria($event)" [label]="auditoria.nome"
              [(checked)]="auditoria.checked" [(disabled)]="auditoria.disabled"></app-checkbox>
          </div>
        </div>
      </app-card-collapse>
    </div>
  </ng-container>

  <div class="my-4">
    <app-card-collapse title="Realizar Consultas">
      <div class="row mb-4">
        <!-- <h3 class="w-100 p-2 mt-2 modal-header mb-4 text-uppercase text-center">Consultas Veiculares</h3> -->
        <div *ngFor="let consulta of veiculos" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox [(checked)]="consulta.checked" (checkedChange)="selecionarConsulta($event)"
            [label]="consulta.nome" [(disabled)]="consulta.disabled"></app-checkbox>
        </div>
        <div *ngFor="let consulta of listaConsultaEspecial" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox [label]="consulta.nome"
            [(disabled)]="consulta.disabled" [(checked)]="consulta.checked" (checkedChange)="selecionarConsultaEspecial($event)"></app-checkbox>
        </div>
      </div>

      <!-- <div class="row" *ngIf="creditos.length > 0">
        <h3 class="w-100 p-2 mt-2 modal-header mb-4 text-uppercase text-center">Consultas de Crédito</h3>
        <div *ngFor="let consulta of creditos" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox [(checked)]="consulta.checked" (checkedChange)="selecionarConsulta($event)" 
            [label]="consulta.nome" [(disabled)]="consulta.disabled"></app-checkbox>
        </div>
      </div> -->
      <div class="text-danger py-0 f-12  d-flex justify-content-end" *ngIf="textObrigatoriedade"> *Campo obrigatório</div>
    </app-card-collapse>
  </div>

  <div class="my-4">
    <app-card-collapse title="Nomenclatura do parecer">
      <div class="pb-3">
        <app-input-radio name="nomenclatura" value="1" [(model)]="nomenclatura"
          label="Aprovado / Aprovado com restrição / Aprovado com apontamento / Reprovado"></app-input-radio>
      </div>
      <div class="pb-3">
        <app-input-radio name="nomenclatura" value="2" [(model)]="nomenclatura"
          label="Conforme / Conforme com restrição / Conforme com apontamento / Não conforme"></app-input-radio>
      </div>
      <div class="pb-3">
        <app-input-radio name="nomenclatura" value="3" [(model)]="nomenclatura"
          label="Conforme / Com Restrição / Com Apontamento / Não Conforme"></app-input-radio>
      </div>
      <div>
        <app-input-radio name="nomenclatura" value="4" [(model)]="nomenclatura"
          label="Sem Apontamento / Com Apontamento"></app-input-radio>
      </div>
    </app-card-collapse>
  </div>

  <div class="my-4" *ngFor="let g of config.groups">
    <app-card-collapse [title]="g.label">

      <ng-container *ngFor="let f of g.fields">
        <div class="card my-1" [ngClass]="{'bg-gray-300': f.type=='0'}">
          <div class=" p-2 d-flex align-items-center flex-wrap flex-sm-nowrap">
            <div class="w-100">{{f.label}}</div>
            <div class="bg-light px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" (checkedChange)="selecionarVisivel($event, f, g)" label="Visível"
                [(checked)]="f.visivel"></app-checkbox>
            </div>
            <div class="bg-light px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" [disabled]="!f.visivel" (checkedChange)="selecionarObrigatorio($event, f, g)"
                label="Obrigatório" [(checked)]="f.obrigatorio"></app-checkbox>
            </div>
            <div class="bg-light px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" [disabled]="!f.visivel" (checkedChange)="selecionarImprimir($event, f, g)"
                label="Imprimir" [(checked)]="f.imprimir"></app-checkbox>
            </div>
          </div>

          <div class="bg-light d-flex align-items-center  flex-wrap flex-sm-nowrap px-2 py-1" *ngIf="f.img">
            <div class="w-100">{{f.img.label}}</div>
            <div class="bg-white px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" [disabled]="!f.visivel" (checkedChange)="selecionarVisivel($event, f.img, g)"
                label="Visível" [(checked)]="f.img.visivel"></app-checkbox>
            </div>
            <div class="bg-white px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" [disabled]="!f.img.visivel || !f.visivel"
                (checkedChange)="selecionarObrigatorio($event, f.img, g)" label="Obrigatório"
                [(checked)]="f.img.obrigatorio"></app-checkbox>
            </div>
            <div class="bg-white px-2 py-1 ml-2 rounded">
              <app-checkbox size="sm" [disabled]="!f.img.visivel || !f.visivel"
                (checkedChange)="selecionarImprimir($event, f.img, g)" label="Imprimir" [(checked)]="f.img.imprimir">
              </app-checkbox>
            </div>
          </div>

        </div>

      </ng-container>

    </app-card-collapse>
  </div>

  <div class="my-4">
    <app-card-collapse title="Texto Padrão">
      <textarea [(ngModel)]="textoPadrao" class="form-control" name="textopadrao" id="textopadrao" rows="3"></textarea>
    </app-card-collapse>
  </div>

  <div class="mt-5 d-flex justify-content-end">
    <button (click)="salvar()" class="btn btn-lg btn-success px-5">
      Confirmar
    </button>
  </div>


</section>